import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1 pb-2" }, [
        _vm._v(_vm._s(_vm.$t("menu.attrs.attribute_quality_shared"))),
      ]),
      _vm._t("default"),
      _c("div", [
        _vm.loadingReport
          ? _c(
              "div",
              { staticClass: "text-center" },
              [
                _c(VProgressCircular, {
                  attrs: { indeterminate: "", color: "primary" },
                }),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.loadingReport,
                expression: "!loadingReport",
              },
            ],
          },
          [
            _c(
              VBtn,
              {
                staticClass: "btn-icon-inca",
                staticStyle: { position: "absolute" },
                attrs: { icon: "" },
                on: { click: _vm.onRecargarReporte },
              },
              [_c(VIcon, [_vm._v("mdi-refresh")])],
              1
            ),
            _c("iframe", {
              key: _vm.key_iframe,
              staticStyle: { width: "100%" },
              style: { height: _vm.inframeHeight + "px" },
              attrs: {
                src: _vm.url_report,
                allowfullscreen: "",
                frameborder: "0",
              },
              on: { load: _vm.loadedIframe },
            }),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }